import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={26}
    viewBox="0 0 16 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.619303 12.7343L13.1186 25.2344L15.3804 22.9718L5.14283 12.7343L15.3804 2.49673L13.1186 0.234375L0.619303 12.7343Z"
      fill="black"
    />
  </svg>
);
export default SVGComponent;
